import {
    Component,
    ElementRef,
    EventEmitter,
    Input,
    Output,
    ViewChild,
    ViewEncapsulation,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { DatePickerComponent } from '../../../../../shared/components/date-picker/date-picker.component';
import { DocSignState } from '../doc-models';
import { DocumentCaseData } from '../../../../../core/services/document.models';

@Component({
    selector: 'app-doc-acknowledgment',
    standalone: true,
    imports: [CommonModule, FormsModule, DatePickerComponent],
    templateUrl: './doc-acknowledgment.component.html',
    encapsulation: ViewEncapsulation.None,
})
export class DocAcknowledgmentComponent {
    @Input() state!:   DocSignState;
    @Input() caseData: DocumentCaseData | null = null;

    @Output() downloadPdf = new EventEmitter<void>();
    @Output() clearSig    = new EventEmitter<void>();
    @Output() mouseDown   = new EventEmitter<MouseEvent>();
    @Output() mouseMove   = new EventEmitter<MouseEvent>();
    @Output() mouseUp     = new EventEmitter<void>();
    @Output() touchStart  = new EventEmitter<TouchEvent>();
    @Output() touchMove   = new EventEmitter<TouchEvent>();
    @Output() touchEnd    = new EventEmitter<void>();

    @ViewChild('docCard',   { read: ElementRef }) docCard!:   ElementRef<HTMLElement>;
    @ViewChild('sigCanvas', { read: ElementRef }) sigCanvas!: ElementRef<HTMLCanvasElement>;

    get patientName():   string { return this.caseData?.patient_first_name ? `${this.caseData.patient_first_name} ${this.caseData.patient_last_name}` : '[Patient First Name] [Patient Last Name]'; }
    get patientLast():   string { return this.caseData?.patient_last_name  ?? '[Last Name]'; }
    get patientFirst():  string { return this.caseData?.patient_first_name ?? '[First Name]'; }
    get providerName():  string { return this.caseData?.provider_name      ?? '[Provider Name]'; }
    get dateOfService(): string { return this.caseData?.date_of_service    ?? '[Date of Service]'; }
    get accountNumber(): string { return this.caseData?.account_number     ?? '[Account #]'; }
    get billedCharges(): string { const v = this.caseData?.full_billed_charges; return v != null ? `$${v.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}` : '$[FBC]'; }
    get trustAmount():   string { const v = this.caseData?.trust_amount;        return v != null ? `$${v.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}` : '$[Trust Amount]'; }
    get attorneyName():  string { return this.caseData?.attorney_name ?? ''; }
}
